<template>

    <div class="app-input textarea" :class="{'has-error': error && error.length}">
        <label v-if="label" :id="label">{{ label }}</label>

        <div class="app-input-wrap">
            <div class="start-icon" v-if="startIcon" v-html="$icon(startIcon)"></div>

            <textarea
                :id="label || id"
                :autofocus="autofocus"
                :disabled="disabled || loading"
                :placeholder="placeholder"
                :class="{'has-start-icon': startIcon}"
                @focus="$emit('focus', $event)"
                @blur="$emit('blur', $event)"
                @input="onInput"
                v-model="newValue">
            </textarea>

            <div class="icon" v-if="icon" v-html="$icon(icon)"></div>
            <div class="loader" v-if="loading" v-html="$icon('loader')"></div>
        </div>

        <p class="message" v-if="message">{{ message }}</p>
        <p class="error" v-if="error">{{ error }}</p>
    </div>

</template>

<script>

export default {
    name: 'app-input',

    emits: ['update:modelValue', 'focus', 'blur', 'change'],

    props: {
        type: {
            type: String,
            default: "text"
        },
        modelValue: [String, Number],
        icon: [String, Boolean],
        startIcon: [String, Boolean],
        label: String,
        id: String,
        value: [String],
        placeholder: String,
        message: String,
        error: String,
        autofocus: Boolean,
        loading: false,
        disabled: false
    },

    data() {
        return {
            newValue: this.modelValue,
            focused: false
        }
    },

    watch: {
        value() {
            this.newValue = this.modelValue;
        }
    },

    methods: {

        onInput() {
            this.$emit('update:modelValue', this.newValue);
            this.$emit('change', this.newValue);
        }

    },

    computed: {
        filled() {
            return this.newValue || this.focused
        },
    }

}

</script>

<style lang="scss" scoped>
.app-input {

    .loader {
        ::v-deep svg {
            stroke: black;
        }
    }

}



</style>
